import React from 'react';
import { ArrowRight } from 'lucide-react';

const scrollTo = (id) => {
  const element = document.getElementById(id);
  if (element) {
    const offset = 130;
    const top = element.getBoundingClientRect().top + window.pageYOffset - offset;
    window.scrollTo({ top, behavior: 'smooth' });
  }
};

const HeroSection = () => {
  return (
    <section id="inicio" className="relative min-h-screen bg-[#FAFAF8]">
      <div className="grid lg:grid-cols-2 min-h-screen">
        {/* Editorial Text Side */}
        <div className="flex items-center px-6 sm:px-12 lg:px-20 pt-48 pb-20 lg:pt-40">
          <div className="max-w-xl">
            <p className="text-xs font-medium uppercase tracking-[0.3em] text-gold-700 mb-8 animate-fade-in">
              Medicina Estética Premium
            </p>

            <h1 className="text-5xl sm:text-6xl lg:text-7xl font-serif font-light text-gray-900 leading-[1.05] mb-8">
              La ciencia de
              <span className="block text-sage-700 mt-2">la belleza natural</span>
            </h1>

            <p className="text-lg text-gray-600 mb-12 leading-relaxed font-light">
              Belleza Natural, Resultados Extraordinarios.
            </p>

            <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4 mb-16">
              <button
                onClick={() => scrollTo('contacto')}
                data-testid="hero-cta-valoracion"
                className="group inline-flex items-center bg-[#6E4F35] hover:bg-[#5a3f2a] text-cream-100 px-10 py-4 text-sm font-medium uppercase tracking-[0.15em] transition-colors duration-300"
              >
                Solicitar mi valoración
                <ArrowRight className="ml-3 w-4 h-4 group-hover:translate-x-1 transition-transform" />
              </button>
              <button
                onClick={() => scrollTo('servicios')}
                data-testid="hero-cta-servicios"
                className="inline-flex items-center text-[#6E4F35] border border-[#6E4F35]/40 hover:border-[#6E4F35] px-10 py-4 text-sm font-medium uppercase tracking-[0.15em] transition-colors duration-300"
              >
                Nuestros Servicios
              </button>
            </div>

            {/* Trust Indicators */}
            <div className="grid grid-cols-3 gap-8 pt-8 border-t border-[#E6E4DD]">
              <div>
                <div className="text-3xl font-serif font-semibold text-[#6E4F35] mb-1">100%</div>
                <div className="text-xs uppercase tracking-widest text-[#8B7355]">Personalizado</div>
              </div>
              <div>
                <div className="text-3xl font-serif font-semibold text-[#6E4F35] mb-1">Premium</div>
                <div className="text-xs uppercase tracking-widest text-[#8B7355]">Instalaciones</div>
              </div>
              <div>
                <div className="text-3xl font-serif font-semibold text-[#6E4F35] mb-1">Naturales</div>
                <div className="text-xs uppercase tracking-widest text-[#8B7355]">Resultados</div>
              </div>
            </div>
          </div>
        </div>

        {/* Image Side */}
        <div className="relative hidden lg:block">
          <img
            src="https://images.unsplash.com/photo-1722603729687-f7be6bee59aa?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzF8MHwxfHNlYXJjaHwzfHxtaW5pbWFsaXN0JTIwd29tYW4lMjBmYWNlJTIwY2xlYXIlMjBza2luJTIwbmV1dHJhbCUyMGJhY2tncm91bmR8ZW58MHx8fHwxNzg0Njg5MDQxfDA&ixlib=rb-4.1.0&q=85"
            alt="Belleza natural"
            className="absolute inset-0 w-full h-full object-cover"
            style={{ objectPosition: 'center 70%' }}
          />
          <div className="absolute inset-0 bg-gradient-to-r from-[#FAFAF8]/40 to-transparent"></div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
